/**
 * Detects and permanently removes specific elements from the DOM.
 */
const removeBestSellingOptions = () => {
  const selectors = [
    '#SortBy option[value="best-selling"]',
    '#SortBy-mobile option[value="best-selling"]',
  ];

  selectors.forEach((selector) => {
    const elements = document.querySelectorAll(selector);
    elements.forEach((el) => {
      // If the element being removed is a currently selected option,
      // we reset the select menu to the first available option.
      if (el.tagName === "OPTION" && el.selected) {
        const parent = el.parentElement;
        el.remove();
        if (parent) parent.selectedIndex = 0;
      } else {
        el.remove();
      }
    });
  });
};

// Initial run for static elements
removeBestSellingOptions();

// Watch for dynamically loaded elements (AJAX/Lazy loading)
const observer = new MutationObserver(() => {
  removeBestSellingOptions();
});

observer.observe(document.body, {
  childList: true,
  subtree: true,
});